
export class StoreHours {
	public monOpen: string = '';
	public monClose: string = '';
	public tueOpen: string = '';
	public tueClose: string = '';
	public wedOpen: string = '';
	public wedClose: string = '';
	public thuOpen: string = '';
	public thuClose: string = '';
	public friOpen: string = '';
	public friClose: string = '';
	public satOpen: string = '';
	public satClose: string = '';
	public sunOpen: string = '';
	public sunClose: string = '';

	public monClosed: boolean = false;
	public tueClosed: boolean = false;
	public wedClosed: boolean = false;
	public thuClosed: boolean = false;
	public friClosed: boolean = false;
	public satClosed: boolean = false;
	public sunClosed: boolean = false;

	constructor(o?: any) {
		Object.assign(this, o);
	}
}